import { API_BASE } from './api-client'

export type OAuthProvider = 'google' | 'github'

interface OAuthRedirectOptions {
  apiBase?: string
  location?: Pick<Location, 'hostname' | 'origin' | 'port' | 'protocol'>
}

function isLoopbackIp(hostname: string): boolean {
  return hostname === '127.0.0.1' || hostname === '::1' || hostname === '[::1]'
}

function localCanonicalOrigin(location: Pick<Location, 'hostname' | 'origin' | 'port' | 'protocol'>): string {
  if (!isLoopbackIp(location.hostname)) return location.origin

  const url = new URL(location.origin)
  url.hostname = 'localhost'
  if (location.port) url.port = location.port
  return url.origin
}

export function oauthRedirectUrl(provider: OAuthProvider, options: OAuthRedirectOptions = {}): string {
  const apiBase = options.apiBase ?? API_BASE
  if (apiBase) return `${apiBase}/api/auth/${provider}`

  const location = options.location ?? window.location
  const base = location.protocol === 'http:' ? localCanonicalOrigin(location) : location.origin
  return `${base}/api/auth/${provider}`
}
